<template>
  <!-- <div :class="['w-full pt-[95px] pb-[45px] box-border', reverse ? 'bg-[#e9f2fa]' : 'bg-[#fff]']">
    <div
      :class="['w-full max-w-[1400px] mx-auto flex justify-between items-center', reverse ? 'flex-row-reverse' : 'flex-row']">
      <div class="mb-[45px] w-[280px]">
        <img class="h-full" :src="img" alt="" />
      </div>
      <div class="w-auto max-w-[725px] mb-[45px]">
        <div class="text-[24px] font-bold text-[#042B84] leading-[0.9] mb-[30px]">{{ title }}</div>
        <div class="text-[16px] font-medium text-[#223265] leading-[1.1]">{{ tips }}</div>
        <div class="w-full flex justify-start flex-wrap">
          <div v-for="detail in details"
            class="w-[50%] mt-[30px] text-[18px] font-medium text-[#223265] leading-[16px]">
            <img class="h-[16px] mr-[20px] align-middle inline-block" src="@/assets/index/img/pay/icon_active4.png"
              alt="" />
            <span>{{ detail }}</span>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div :class="['flex flex-col gap-[1.5rem] py-[4rem] px-[3rem] min-h-[38.625rem] text-[#043e5d]', dummy ? '' : 'rounded-[3rem] border border-[#043e5d]']">
    <div v-if="!dummy" class="flex flex-col justify-center items-center w-[5rem] h-[4rem] mb-auto">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"
        viewBox="0 0 80 64" fill="none" preserveAspectRatio="xMidYMid meet" aria-hidden="true" role="img">
        <g clip-path="url(#clip0_762_5522)">
          <path
            d="M51.4621 50.431C64.4173 37.539 66.5436 18.7528 56.2113 8.47087C45.879 -1.81104 27.0007 0.304883 14.0454 13.1969C1.09019 26.089 -1.03611 44.8752 9.29621 55.1571C19.6285 65.439 38.5068 63.3231 51.4621 50.431Z"
            stroke="url(#paint0_linear_762_5522)" stroke-width="1.5" stroke-miterlimit="10"></path>
          <path
            d="M58.5988 50.431C71.554 37.539 73.6803 18.7528 63.348 8.47087C53.0157 -1.81104 34.1374 0.304885 21.1821 13.1969C8.22691 26.089 6.10061 44.8752 16.4329 55.1571C26.7652 65.439 45.6435 63.3231 58.5988 50.431Z"
            stroke="url(#paint1_linear_762_5522)" stroke-width="1.5" stroke-miterlimit="10"></path>
          <path
            d="M65.7355 50.431C78.6907 37.539 80.817 18.7528 70.4847 8.47087C60.1524 -1.81104 41.2741 0.304885 28.3189 13.1969C15.3636 26.089 13.2373 44.8752 23.5696 55.1571C33.902 65.439 52.7803 63.3231 65.7355 50.431Z"
            stroke="url(#paint2_linear_762_5522)" stroke-width="1.5" stroke-miterlimit="10"></path>
        </g>
        <defs>
          <linearGradient id="paint0_linear_762_5522" x1="-0.475917" y1="28.1242" x2="62.2508" y2="35.2057"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#A75A3D"></stop>
            <stop offset="1" stop-color="#BCB2FD"></stop>
          </linearGradient>
          <linearGradient id="paint1_linear_762_5522" x1="6.81718" y1="28.1374" x2="69.5439" y2="35.219"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#BB5831"></stop>
            <stop offset="1" stop-color="#BCB2FD"></stop>
          </linearGradient>
          <linearGradient id="paint2_linear_762_5522" x1="14.1103" y1="28.1506" x2="76.837" y2="35.2322"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#CF5726"></stop>
            <stop offset="1" stop-color="#BCB2FD"></stop>
          </linearGradient>
          <clipPath id="clip0_762_5522">
            <rect width="80" height="64" fill="currentColor"></rect>
          </clipPath>
        </defs>
      </svg>
    </div>

    <div v-if="!dummy" class="w-auto max-w-[725px] mb-[45px]">
      <div class="-tracking-[.025rem] text-[2.5rem] text-[#042B84] leading-[1.3] mb-[30px] font-['Manrope, sans-serif'] font-medium">{{ title }}</div>
      <div class="-tracking-[.025rem] text-[16px] text-[#223265] leading-[1.3] font-['Manrope, sans-serif'] font-medium ">{{ tips }}</div>
      <div class="w-full flex justify-start flex-wrap">
        <div v-for="detail in details"
          class="w-[50%] mt-[30px] text-[16px] font-medium text-[#223265] leading-[16px]">
          <i class="el-icon-circle-check h-[16px] mr-1 align-middle inline-block" alt=""></i>
          <span>{{ detail }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PackageItemView',
  data() {
    return {
    }
  },
  props: {
    dummy: {
      type: Boolean,
      default: false
    },
    reverse: false,
    img: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    tips: {
      type: String,
      required: true
    },
    details: {
      type: Array,
      required: true
    }
  },
  created() {
  },
  computed: {

  },
  methods: {

  },
}
</script>